import { AfterViewInit, Component, inject, input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatCardContent, MatCardModule } from '@angular/material/card';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table';

import { Subscription } from 'rxjs';
import { ModificationLog } from 'src/app/models/modification';
import { ModificationLogService } from 'src/app/services/modificationlog.service';

@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss'],
  imports: [
    MatCardModule,
    MatCardContent,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow
  ]
})
export class AuditLogComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly auditId = input.required<string>();
  // TODO: Skipped for migration because:
  //  There are references to this query that cannot be migrated automatically.
  @ViewChildren('logTableComp', { read: MatSort }) logSort!: QueryList<MatSort>;
  subs: Subscription[] = [];
  modificationLogService = inject(ModificationLogService);
  modificationLogs!: ModificationLog[];
  loaded = false;

  logTable = {
    ready: false,
    data: new MatTableDataSource<ModificationLog>(),
    col: [
      { title: 'This document has been', field: 'action' },
      { title: 'on', field: 'date' },
      { title: 'Actual Audit Status', field: 'status' }
    ]
  };

  ngOnInit() {
    this.loadModifications();
  }

  loadModifications() {
    if (this.auditId()) {
      this.modificationLogService.getModificationLogs(this.auditId()).subscribe({
        next: (modificationLog: ModificationLog[]) => {
          this.loaded = true;
          this.logTable.data.data = modificationLog;
        }
      });
    } else {
      this.loaded = true;
      this.logTable.data.data = [];
    }
  }

  ngAfterViewInit() {
    this.subs.push(
      this.logSort.changes.subscribe({
        next: (data) => {
          if (data.length) {
            this.logTable.data.sort = data.toArray()[0];
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((v) => v.unsubscribe());
  }

  colFields(col: { field: string }[]) {
    return col.map((v) => v.field);
  }
}
